<template lang="pug">
	main#app
		router-view
</template>

<script>
export default {
	name: "template-app",
	components: {},
	data() {
		return {
			// chatBotConversationCount: 1
		};
	}
};
</script>

<style lang="stylus" scoped src="@templates/EmptyApp/EmptyApp.styl"></style>
